import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from "@angular/router";
import { Injectable, inject } from "@angular/core";
import {AuthService} from "../service/auth.service";
import {Observable} from "rxjs";

@Injectable()
export class IndexGuard  {
    protected authService = inject(AuthService);
    protected router = inject(Router);


    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        if (this.authService.isLoggedIn() && this.authService.getUser() != null) {
            this.router.navigateByUrl('/');
            return false;
        }
        return true;
    }

}
